module.exports = __webpack_public_path__ + "static/ma-5-sq-35769099abd6db0d28da28df9ea43b09.png";